exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error_message {\n  text-align: center;\n  margin-top: 50px; }\n\n.error_message h3 {\n  padding: 30px 30px;\n  margin: auto; }\n\n.testata .logo {\n  margin-top: 80px;\n  margin-bottom: 80px;\n  max-height: 200px;\n  max-width: 320px; }\n\n.testata {\n  background: #dfdfdf;\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/andrea/Documents/Projects/SW40/landing-portale-privacy/src/app/confirm-page/confirm-page.component.scss
// module id = ../../../../../src/app/confirm-page/confirm-page.component.scss
// module chunks = main